import { formatThousandsAndDecimals } from "@/lib/formatters/numbers";
import { IndentValues } from "@/lib/utils/IndentValues";
import { Box, Indent, Txt } from "@stenajs-webui/core";
import { Icon, stenaInfoCircle } from "@stenajs-webui/elements";
import { Tooltip } from "@stenajs-webui/tooltip";
import { isConvertedPrice } from "../lib/priceListValues";
import { PriceListRow } from "../types/PriceListRow";

interface Props {
  row: PriceListRow;
  conversionCurrency: string | undefined;
}

/**
 * The icon follows the price rather than sitting at the cell's far edge. Price
 * is the last column, so that edge is where the table's scrollbar appears and
 * the icon would sit underneath it.
 */
export const ConvertedPriceCell = ({ row, conversionCurrency }: Props) => {
  const converted =
    conversionCurrency != null && isConvertedPrice(row, conversionCurrency);

  return (
    <Box width={"calc(100% - 8px)"} overflow={"hidden"}>
      <Indent
        num={IndentValues.EIGHT}
        flexDirection={"row"}
        alignItems={"center"}
        gap={1}
      >
        <Txt
          variant={"bold"}
          overflow={"hidden"}
          textOverflow={"ellipsis"}
          whiteSpace={"nowrap"}
          style={{ minWidth: 0 }}
        >
          {formatThousandsAndDecimals(row.convertedPrice)}
        </Txt>
        {converted && (
          <Tooltip
            label={`Converted from ${formatThousandsAndDecimals(row.price)} ${
              row.routeAgreementCurrency
            }`}
            placement={"top"}
            appendTo={document.body}
          >
            <Icon
              icon={stenaInfoCircle}
              size={12}
              data-testid={"price-list-converted-price"}
              aria-label={`Converted from ${row.routeAgreementCurrency}`}
            />
          </Tooltip>
        )}
      </Indent>
    </Box>
  );
};
